module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: "https://api-node.themesbrand.website",
  },
  base_url: {
    casdoor: "https://casdoor.siga-ltda.click",
    erp_auth: "https://erp-auth.siga-ltda.click",
    erp_config: "https://erp-config.siga-ltda.click",
    erp_backend: "https://erp-backend.siga-ltda.click",
    erp_img_records: "https://img-records.siga-ltda.click",
  },
};
